var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-12 text-center" }, [
      _c("h4", { staticClass: "highlight-color" }, [
        _vm._v(_vm._s(_vm.$t("message.verifyemail")))
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "highlight-color" }, [
        _vm._v(_vm._s(_vm.$t("message.intro1")))
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-6 form" },
      [
        !_vm.ready
          ? _c("p", { staticClass: "m-0 text-center" }, [
              _vm._v("\n      " + _vm._s(_vm.$t("message.pleasewait")) + " "),
              _c("i", { staticClass: "fas fa-spinner spin" })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.ready
          ? [
              _vm.verify_success
                ? _c("p", { staticClass: "m-0 text-center text-success" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("message.youremailhasbeenverified")) +
                        " "
                    ),
                    _c("i", { staticClass: "far fa-check-circle" })
                  ])
                : _c("p", { staticClass: "m-0 text-center text-danger" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("message.notfounddata")) +
                        "\n      "
                    )
                  ])
            ]
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-12 text-center" }, [
      _vm.ready
        ? _c(
            "p",
            { staticClass: "text-white mb-1" },
            [
              _c(
                "router-link",
                {
                  staticClass: "text-white",
                  attrs: {
                    to: {
                      name: "SignIn"
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("message.login")) + "\n      "
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo col-md-12 text-center" }, [
      _c("img", { attrs: { src: require("./../../assets/logo-10.png") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b1e1466", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b1e1466","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/CheckVerifyEmail.vue
// module id = null
// module chunks = 